import {
  DETAILS_MAP,
  INTERNATIONAL,
  SERVICE_TYPE_LABEL_MAP,
  detailsConfig,
} from "../constants";
import {
  IDetailFileFrontEndModel,
  IDetailsViewModel,
  IGetServiceBackEndModel,
  IGetViewServiceBackEndModel,
  IManageServiceFormModel,
  IServiceByProviderListItemBackEndModel,
  IServiceByProviderListItemFrontEndModel,
  IViewMoreServiceBackEndModel,
  IViewMoreServiceFrontEndModel,
  IViewServiceModel,
} from "../types";
import { getName } from "country-list";

export function parseServicesByProviderToFrontEndModel(
  backEndModel: IServiceByProviderListItemBackEndModel[],
): IServiceByProviderListItemFrontEndModel[] {
  return backEndModel.map((serviceBackEnd) => ({
    id: serviceBackEnd.id,
    serviceProductType: SERVICE_TYPE_LABEL_MAP[serviceBackEnd.serviceProductType],
    countries: serviceBackEnd.countries,
  }));
}

export function parseManageServiceToFrontEndModel(
  backEndModel: IGetServiceBackEndModel,
): IManageServiceFormModel {
  const parsedCountries =
    backEndModel.countries.length === 0
      ? [
          {
            code: INTERNATIONAL,
            name: "International",
            group: "",
          },
        ]
      : backEndModel.countries
          .map((code) => ({
            code: code,
            name: getName(code)!,
            group: "All Countries",
          }))
          .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0));

  const parsedDetails = backEndModel.details.reduce((obj, backEndDetail) => {
    obj[`type_${backEndDetail.type}`] = backEndDetail.content;
    return obj;
  }, {});

  const parsedDetailFiles = backEndModel.detailFiles.map((df) => ({
    id: df.fileId,
    name: df.name,
    size: df.size,
    preview: df.path,
  }));

  return {
    id: backEndModel.id,
    serviceType: {
      id: backEndModel.serviceProductType,
      name: SERVICE_TYPE_LABEL_MAP[backEndModel.serviceProductType],
    },
    countries: parsedCountries,
    details: parsedDetails,
    detailFiles: parsedDetailFiles,
  };
}

export function parseViewServiceToFrontEndModel(
  backEndModel: IGetViewServiceBackEndModel,
): IViewServiceModel {
  const parsedCountries = backEndModel.countries;

  const details: IDetailsViewModel[] = [];

  detailsConfig.forEach((config) => {
    const foundDetail = backEndModel.details.find(
      (detail) => detail.type === config.type,
    );

    if (foundDetail) {
      details.push({
        type: config.type,
        name: config.name,
        content: foundDetail.content,
      });
    }
  });

  const detailFiles: IDetailFileFrontEndModel[] = backEndModel.detailFiles.map(
    (file) => ({
      id: file.fileId,
      name: file.name!,
      size: file.size!,
      path: file.path!,
    }),
  );

  return {
    serviceTypeName: SERVICE_TYPE_LABEL_MAP[backEndModel.serviceProductType],
    countries: parsedCountries,
    details: details,
    detailFiles: detailFiles,
  };
}

export function parseViewMoreServiceToFrontEndModel(
  service: IViewMoreServiceBackEndModel,
): IViewMoreServiceFrontEndModel {
  const serviceProviderImage = service.serviceProvider.image?.preview;
  const serviceProviderCountry =
    service.serviceProvider.country ?? getName(service.serviceProvider.country);
  const serviceTypeName = SERVICE_TYPE_LABEL_MAP[service.serviceProductType];

  const details = service.details.map((detail) => ({
    name: DETAILS_MAP[detail.type],
    content: detail.content,
    type: detail.type,
  }));

  const parsedCountries =
    service.countries.length === 0
      ? ["International"]
      : service.countries
          .map((code) => getName(code)!)
          .sort((a, b) => (a > b ? 1 : b > a ? -1 : 0));

  return {
    id: service.id,
    serviceTypeName: serviceTypeName,
    countries: parsedCountries,
    serviceProvider: {
      id: service.serviceProvider.id,
      name: service.serviceProvider.name,
      country: getName(serviceProviderCountry)!,
      image: serviceProviderImage,
    },
    details: details,
    extraDocuments: service.detailFiles,
  };
}
